export default __webpack_public_path__ + "static/Bluetooth-Low-Energy-df2cf8e82372bf6654695c80ade7b3b9.webp";